import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  title: {
    marginBottom: theme.spacing(3),
  },
  input: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      '& input': {
        fontSize: 14,
      },
    },
    '& .css-19idom': {
      height: 20,
      marginBottom: theme.spacing(0.5),
      [theme.breakpoints.down('lg')]: {
        height: 'auto',
        marginBottom: theme.spacing(1),
      },
    },
  },
  addressType: {
    marginTop: theme.spacing(0.125),
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(1.75),
    },
  },
  inputContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    '& > div': {
      flexBasis: 'calc(50% - 10px)',
      maxWidth: 'calc(50% - 10px)',
      '&:nth-child(1)': {
        marginRight: 20,
      },
      '&:nth-child(3)': {
        marginRight: 20,
      },
    },
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
      flexDirection: 'column',
      '& > div': {
        maxWidth: 'none',
        flexBasis: '100%',
        marginRight: '0 !important',
      },
    },
  },
  select: {
    marginTop: theme.spacing(1),
    '& fieldset': {
      backgroundColor: 'transparent !important',
      border: '1px solid rgba(0, 0, 0, 0.23) !important',
      borderRadius: '10px',
    },
    '& .MuiSelect-select': {
      color: '#1E1E1E',
      fontSize: 16,
      fontWeight: 400,
    },
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiSelect-select': {
        fontSize: 14,
      },
    },
    '& .css-19idom': {
      height: 20,
      marginBottom: theme.spacing(0.5),
      [theme.breakpoints.down('lg')]: {
        height: 'auto',
        marginBottom: theme.spacing(1),
      },
    },
  },
  zip: {
    '& .MuiTextField-root': {
      width: '45%',
      [theme.breakpoints.down('md')]: {
        width: 148,
      },
    },
  },
  uspsError: {
    color: colors.gilead.primary1,
    marginBottom: theme.spacing(1),
  },
}));
